let cache = localStorage.getItem("geoData");
let cacheTime = localStorage.getItem("geoDataTime");
let now = Date.now();

// Expire cache every 24 hours
if (cache && cacheTime && now - cacheTime < 86400000) {
  geoHandler(JSON.parse(cache));
} else {
  $.get("https://ipapi.co/json/", function (data) {
    localStorage.setItem("geoData", JSON.stringify(data));
    localStorage.setItem("geoDataTime", now);
    geoHandler(data);
  });
}

/* =======================
   OLD GEO REDIRECT CODE — DISABLED FOR TESTING
==========================

jQuery(document).ready(function ($) {
  // Check if we already have saved geo data
  let userData = localStorage.getItem("geoData");

  if (userData) {
    geoHandler(JSON.parse(userData));
  } else {
    // Fetch user geo info from ipapi.co (CORS friendly)
    $.get("https://ipapi.co/json/", function (data) {
      localStorage.setItem("geoData", JSON.stringify(data));
      console.log("Latest Theme 8.0.0");
      geoHandler(data);
    }).fail(function () {
      console.error("Geo API request failed.");
    });
  }

  // Function to handle user country logic
  function geoHandler(data) {
    var countryCode = data.country_code;
    var referrer = document.referrer;

    console.log("User Country Code:", countryCode);
    console.log("Referrer:", referrer);

    // Redirect or handle logic based on country and referrer
    if (referrer === "" && countryCode === "PK") {
      // window.location.href = "https://bokitta.pk";
      console.log("Pakistan visitor — stay on .com");
    } else if (referrer === "" && countryCode === "IN") {
      window.location.href = "https://bokitta.in";
    } else if (referrer === "" && countryCode === "GB") {
      window.location.href = "https://bokitta.co.uk";
    } else if (countryCode === "NP") {
      alert("🚫 This website is not available in your country!");
      window.location.href = "https://www.google.com";
    }
  }
});
==========================
   END OLD CODE
========================== */
document.addEventListener("DOMContentLoaded", function () {

  // Wait until jQuery is available (important for some Shopify themes)
  function waitForjQuery(callback) {
    if (window.jQuery) {
      callback(window.jQuery);
    } else {
      setTimeout(() => waitForjQuery(callback), 50);
    }
  }

  waitForjQuery(function ($) {

    let userData = localStorage.getItem("geoData");

    if (userData) {
      geoHandler(JSON.parse(userData));
    } else {
      $.get("https://ipapi.co/json/", function (data) {
        localStorage.setItem("geoData", JSON.stringify(data));
        console.log("Latest Theme 8.0.0");
        geoHandler(data);
      }).fail(function () {
        console.error("Geo API request failed.");
      });
    }

    function geoHandler(data) {
      var countryCode = data.country_code;
      var referrer = document.referrer;

      console.log("User Country Code:", countryCode);
      console.log("Referrer:", referrer);

      // ✳️ Your redirect logic
      if (referrer === "" && countryCode === "PK") {
        console.log("Pakistan visitor — stay on .com");
      } 
      else if (referrer === "" && countryCode === "IN") {
        window.location.href = "https://bokitta.in";
      } 
      else if (referrer === "" && countryCode === "GB") {
        window.location.href = "https://bokitta.co.uk";
      } 
      else if (countryCode === "NP") {
        alert("🚫 This website is not available in your country!");
        window.location.href = "https://www.google.com";
      }
    }

  });
});
